import { IResourceType } from "../../../@types/resource.type";



export const includeCustomFieldsfromApi = (resource:IResourceType) => {

  const customFieldsObject = Array.isArray(resource.customFields)
  ? Object.fromEntries(
      resource.customFields.map(({ key, value }) => [key, value])
    )
  : {};

  return {
    ...resource,
    customFieldsObject,
    customFields: undefined,
  }
}


export const includeCustomFieldstoApi = (resource:IResourceType, formDataCustomFields: Record<string, any>) => {

  const customFields = Object.entries(formDataCustomFields).map(([key, value]) => ({ key, value: value !== null ? String(value) : value })); 

  return {
    ...resource,
    customFields,
  }
}
